import { createElementBlock, createElementVNode, openBlock } from "vue";
//#region src/library/icons/computer-device-mobile-phone-iphone-x.svg
var _hoisted_1 = {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 256 256"
};
function render(_ctx, _cache) {
	return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [createElementVNode("path", { d: "M180 144h-20v-32h20a36 36 0 1 0-36-36v20h-32V76a36 36 0 1 0-36 36h20v32H76a36 36 0 1 0 36 36v-20h32v20a36 36 0 1 0 36-36m-20-68a20 20 0 1 1 20 20h-20ZM56 76a20 20 0 0 1 40 0v20H76a20 20 0 0 1-20-20m40 104a20 20 0 1 1-20-20h20Zm16-68h32v32h-32Zm68 88a20 20 0 0 1-20-20v-20h20a20 20 0 0 1 0 40" }, null, -1)])]);
}
var computer_device_mobile_phone_iphone_x_default = { render };
//#endregion
export { computer_device_mobile_phone_iphone_x_default as default, render };

//# sourceMappingURL=computer-device-mobile-phone-iphone-x.svg.js.map